export default __webpack_public_path__ + "static/media/080_finish_good.first.00ff9c7e.webp";